import React, { forwardRef } from "react";

const GeneralInput = forwardRef(
  ({ type = "text", titulo, placeholder, onChange, onKeyDown }, ref) => {
    return (
      <div data-figma-id="933:13808" class="correo-8">
        <p data-figma-id="933:13809" class="correo-titulo-3">
          {titulo}
        </p>
        <input
          id="modal_publico"
          type={type}
          placeholder={placeholder}
          ref={ref}
          onChange={onChange}
          onKeyDown={onKeyDown}
          className="correo-ejemplo-3"
        />
      </div>
    );
  }
);

export default GeneralInput;
